import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import AddHba1cMeasurementMutation from './AddHba1cMeasurementMutation';
import LaboratoryTestsQuery from '../Fetch/LaboratoryTestsQuery';

const AddHba1cMeasurementConnectorApollo = ({ children }) => {
  const [addBloodSugar, { data, loading, error }] = useMutation(AddHba1cMeasurementMutation);

  const createAddMeasurement = async (request) => {
    const response = await addBloodSugar({
      variables: { request },
      awaitRefetchQueries: true,
      refetchQueries: [
        {
          query: LaboratoryTestsQuery,
        },
      ],
    });

    return response;
  };

  return children({
    addHba1cMeasurement: {
      addMeasurement: createAddMeasurement,
      response: data,
      loading,
      error,
    },
  });
};

AddHba1cMeasurementConnectorApollo.propTypes = {
  children: PropTypes.func.isRequired,
};

export default AddHba1cMeasurementConnectorApollo;
